
// CSS
require('./node_modules/font-awesome/css/font-awesome.css')
require('./node_modules/bootstrap-select/dist/css/bootstrap-select.css')
require('./node_modules/bootstrap/dist/css/bootstrap.min.css')
require('./node_modules/owl.carousel/dist/assets/owl.carousel.min.css')
require('./src/css/blockgrid.css')
require('./src/css/custom.css')
require('./node_modules/angular-bootstrap-scrolling-tabs/scrolling-tabs.css')

// JS
require('bootstrap')
require('bootstrap-select')
require('angular')
require('lodash')
require('./node_modules/angular-i18n/angular-locale_it-it.js')
require('angular-ui-bootstrap')
require('script-loader!./node_modules/owl.carousel/dist/owl.carousel.min.js')
require('./src/js/custom.js')
require('script-loader!./node_modules/url-polyfill/url-polyfill.js')
require('script-loader!./node_modules/promise-polyfill/promise.js')



// WEBPACK FOOTER //
// ./vendors.js